import axios from 'axios';
import { getAccessToken, logout } from './auth';

const URL = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api`;

const client = axios.create({
    baseURL: URL,
    json: true
})

export default {
    async execute(method, resource, data) {
        let accessToken = getAccessToken();
        return client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data;
        }).catch(error => {
            if (error.response) {
                return error.response.data;
            } else {
                return 'Impossible d\'atteindre le serveur.';
            }
        });
    },
    getInfo() {
        return this.execute('get', '/info');
    },
    getStats(){
        return this.execute('get', '/stats');
    },
    getInfosById(){
        return this.execute('get', `/infosById`);
    },
    getSites() {
        return this.execute('get', '/sites');
    },
    getFonctions(rht) {
        return this.execute('post', '/fonctions', {rht});
    },
    getEmployes() {
        return this.execute('get', '/employes');
    },
    getEmployeById(id) {
        return this.execute('get', `/employes/${id}`);
    },
    getHorairesGeneral() {
        return this.execute('get', `/horaires/general/gest`);
    },
    getHorairesParEmploye(id){
        return this.execute('get', `/horaires/employe/${id}`);
    },
    getAllRemplacements() {
        return this.execute('get', `/remplacements/all`);
    },
    accepterRefuserRemplacement(id, accepter) {
        return this.execute('post', `/remplacements/${accepter ? 'accepter' : 'refuser'}/${id}`);
    },
    getHeuresByDate(date) {
        let parts = date.split('-');
        return this.execute('get', `/heures/all/${parts[0]}/${parts[1]}/${parts[2]}`);
    },
    updateHeuresByDate(heures, date) {
        let parts = date.split('-');
        return this.execute('post', `/heures/update/${parts[0]}/${parts[1]}/${parts[2]}`, { heures });
    },
    generateHours(date) {
        let parts = date.split('-');
        return this.execute('post', `/heures/generate/${parts[0]}/${parts[1]}/${parts[2]}`);
    },
    getHeuresByEmploye(begindate, enddate, employeid) {
        return this.execute('get', `/heures/employe/${begindate}/${enddate}/${employeid}`)
    },
    getHeuresSummary(begindate, enddate) {
        return this.execute('get', `/heures/summary/${begindate}/${enddate}`);
    },
    getVacancesByEmploye(year, employeid) {
        return this.execute('get', `/vacances/employe/${year}/${employeid}`);
    },
    addVacances(debut, fin, employeid) {
        return this.execute('post', `/vacances`, { debut, fin, employeid });
    },
    deleteVacances(id) {
        return this.execute('delete', `/vacances/${id}`);
    },
    login(username, password) {
        return this.execute('post', '/login', { username, password });
    },
    getUser() {
        return this.execute('get', `/employes/@me`);
    },
    getTemplateList() {
        return this.execute('get', `/templates`);
    },
    getTemplateById(id) {
        return this.execute('get', `/templates/${id}`);
    },
    getNotifications() {
        return this.execute('get', `/notifications`);
    },
    getHorairesProblemes() {
        return this.execute('get', `/horaires/problemes`);
    },
    remplacementGlobal(id_employe_remplacer, id_employe_par, startDate, endDate, filters) {
        return this.execute('post', `/horaires/remplacement`, { id_employe_remplacer, id_employe_par, startDate, endDate, filters });
    },
    getDateMax() {
        return this.execute('get', `/settings/datemax`)
    },
    setDatemax(datemax) {
        return this.execute('post', `/settings/datemax`, { date: datemax })
    },
    getPeriodes() {
        return this.execute('get', `/settings/periodes`)
    },
    setPeriodes(periodes) {
        return this.execute('post', `/settings/periodes`, { periodes })
    },
    getSyncTime() {
        return this.execute('get', `/settings/synctime`)
    },
    setSyncTime(syncTime) {
        return this.execute('post', `/settings/synctime`, { syncTime })
    },
    getHorairesByDate(date) {
        let parts = date.split('-');
        return this.execute('get', `/horaires/date/${parts[0]}/${parts[1]}/${parts[2]}`);
    },
    updateHoraires(horaires) {
        return this.execute('patch', `/horaires`, { horaires });
    },
    saveTemplate(template) {
        return this.execute('patch', `/templates`, { template });
    },
    createTemplate(nom, id_site) {
        return this.execute('post', `/templates`, { nom, id_site });
    },
    generateHoraires(id_template, startDate, endDate) {
        return this.execute('post', `/horaires/generer`, { id_template, startDate, endDate });
    },
    deleteHoraires(startDate, endDate, sites) {
        return this.execute('post', `/horaires/supprimer`, { startDate, endDate, sites });
    },
    synchroniserEmployes() {
        return this.execute('post', '/users/forceupdate');
    },
    getLastLogs() {
        return this.execute('get', `/logs`);
    },
    getQSPsValidation() {
        return this.execute('get', `/qsp/validation`);
    },
    getQSPsProposition() {
        return this.execute('get', `/qsp/propositions`);
    },
    validerQSP(id, valider) {
        return this.execute('patch', `/qsp/validation/${id}`, { valider });
    },
    getHoraireById(id) {
        return this.execute('get', `/horaires/search/${id}`);
    },
    getParticularites() {
        return this.execute('get', `/particularites`);
    },
    createParticularite(particularite) {
        return this.execute('post', `/particularites`, { particularite });
    },
    deleteParticularite(id) {
        return this.execute('delete', `/particularites/${id}`);
    },
    getParticulariteById(id) {
        return this.execute('get', `/particularites/${id}`);
    },
    modifyParticularite(particularite) {
        return this.execute('patch', `/particularites`, { particularite });
    },
    deleteTemplate(id) {
        return this.execute('delete', `/templates/${id}`);
    },
    renameTemplate(id, name) {
        return this.execute('patch', `/templates/rename`, { id, name });
    },
    setAdmin(id, admin) {
        return this.execute('patch', `/employes/${id}/${admin}`);
    },
    setQSPVacances(horaire) {
        return this.execute('patch', `/qsp/vacances`, { horaire });
    },
    deleteAllHoraire(confirm) {
        return this.execute('delete', `/horaires`, { confirm });
    },
    pdf(url, params, filename) {
        axios(`${URL}/pdf/${url}`, {
            method: "GET",
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${getAccessToken()}`
            },
            params
        })
            .then(response => {
                const blob = new Blob([response.data], {
                    type: "application/pdf"
                });
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = `${filename}.pdf`;
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                if (error.response.status === 403) {
                    logout();
                }
            });
    },
    ical(url, params, filename) {
        axios(`${URL}/ical/${url}`, {
            method: "GET",
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${getAccessToken()}`
            },
            params
        })
            .then(response => {
                if (response.data) {
                    const blob = new Blob([response.data], {
                        type: "octet/stream"
                    });
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    let url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = `${filename}.ics`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            })
            .catch(error => {
                if (error.response.status === 403) {
                    router.push('/login');
                }
            });
    }
}